import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { token } from "../theme/tokens.js";
const DEFAULT_COUNT = 6;
export function GalleryLoadingSkeleton({ count = DEFAULT_COUNT }) {
    const cardStyle = {
        width: "100%",
        borderRadius: token("cardRadius"),
        border: `1px solid ${token("cardBorder")}`,
        background: token("cardBg"),
        overflow: "hidden",
    };
    const thumbStyle = {
        width: "100%",
        aspectRatio: `4 / 3`,
        background: "linear-gradient(90deg, var(--color-surface-low) 25%, var(--button-gray-1) 50%, var(--color-surface-low) 75%)",
        backgroundSize: "200% 100%",
        animation: "gallery-skeleton-pulse 1.5s ease-in-out infinite",
    };
    const bodyStyle = {
        padding: "12px",
    };
    const lineLong = {
        height: "14px",
        width: "70%",
        borderRadius: "4px",
        background: "var(--color-surface-low)",
        marginBottom: "8px",
    };
    const lineShort = {
        height: "12px",
        width: "40%",
        borderRadius: "4px",
        background: "var(--color-surface-low)",
    };
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: `
        @keyframes gallery-skeleton-pulse {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      ` }), Array.from({ length: count }, (_, i) => (_jsxs("div", { style: cardStyle, "aria-hidden": "true", children: [_jsx("div", { style: thumbStyle }), _jsxs("div", { style: bodyStyle, children: [_jsx("div", { style: lineLong }), _jsx("div", { style: lineShort })] })] }, i)))] }));
}
//# sourceMappingURL=GalleryLoadingSkeleton.js.map